export interface Stat {
  id: string;
  value: number;
  suffix: string;
  label: string;
}

export const heroStats: Stat[] = [
  { id: "years", value: 17, suffix: "+", label: "años de experiencia" },
  { id: "projects", value: 12, suffix: "+", label: "proyectos desarrollados" },
  { id: "homes", value: 240, suffix: "", label: "casas construidas" },
  { id: "region", value: 1, suffix: "", label: "Región Metropolitana" },
];

export const experienceStats: Stat[] = [
  { id: "years", value: 17, suffix: "+", label: "Años de experiencia" },
  { id: "projects", value: 12, suffix: "+", label: "Proyectos inmobiliarios" },
  { id: "homes", value: 240, suffix: "", label: "Casas construidas" },
  { id: "stage", value: 2023, suffix: "", label: "Nueva etapa con ADJ" },
];

export const timeline: { value: string; label: string }[] = [
  { value: "+17 años", label: "Experiencia inmobiliaria" },
  { value: "+12", label: "Proyectos desarrollados" },
  { value: "240", label: "Casas construidas" },
  { value: "2023", label: "Nacimiento de Inmobiliaria ADJ SpA" },
];